import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDuaRI9W70-Vw2ZFx79RavwYXHy0ywnXJE",
  authDomain: "samegua-seguridadapp.firebaseapp.com",
  projectId: "samegua-seguridadapp",
  storageBucket: "samegua-seguridadapp.firebasestorage.app",
  messagingSenderId: "1044280815950",
  appId: "1:1044280815950:web:4e15560f7f1f49b27bee1f",
  measurementId: "G-VY8V4RD3E6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const messaging = getMessaging(app);